import React from 'react';
import {connect} from 'react-redux';
import Popup from '../../../../components/popup/index';
import UserStatusesPopupMessage from './components/user-statuses-popup-message';
import TransferOwnershipPopupMessage from './components/transfer-ownership-popup-message';
import {
    addToContactSwitch,
    autoCompleteEnteredValue, collaboratorsPageNumber,
    getAutoComplete, getSharingDetailsLv2Popup,
    invalidShare, ownershipChangeTarget, resetAddedCollaborators
} from '../../../../../actions/sharingDetailsActions';
import {isEmailValid, isEmpty} from '../../../../../actions/addCollaboratorActions';
import {selectContactToAdd, selectLabelToAdd} from "../../../../../actions/contactActions";
import './index.css';


class SharingDetailsLv2Popup extends React.Component {

	constructor(props){
		super(props);

		this.closePopup = this.closePopup.bind(this);
		this.resend = this.resend.bind(this);
	}

	closePopup(){
		this.props.getSharingDetailsLv2Popup([]);

		switch (this.props.sharingDetailsLv2Popup[1]) {
			case 'transfer_ownership':
				this.props.ownershipChangeTarget(null);

				this.props.updateCollaborators.forEach( item => {
					if(item.permission === "OWNER"){
						if(document.getElementById(item.id + "0").checked) {
							document.getElementById(item.id + "0").click();
						}
					}
				});
				break;
			default:
				break;
		}
	}

	resend(){
		window.open('https://mail.google.com/mail/u/0/?view=cm&fs=1&to=' + this.props.sharingDetailsLv2Popup[3] + '&su=' + this.props.profile.name + ' shared contacts with you' +
			'&body=Hello,%0A%0AI am sharing my group of contacts called ' + this.props.selectedContactsGroup.name + ' with you.%0A%0A' +
			'To accept the invitation, please click on this link: ' + window.location.origin + '/invited' +
			'%0A%0A--%0ABest regards,%0A'+
			this.props.profile.name +'&tf=1',
			'Send email',
			'_blank,width=990,height=600');
	}

	contentPopup(){
		switch (this.props.sharingDetailsLv2Popup[1]) {
            case "user_collaboratorStatuses":
                return <UserStatusesPopupMessage/>;
            case "transfer_ownership":
                return <TransferOwnershipPopupMessage getBack={this.closePopup}/>;
			default:
				return null;
        }
	}

	render(){
		if(this.props.sharingDetailsLv2Popup[0] === true) {
			return (
				<Popup
					lv2={true}
					onClose={this.closePopup}
					className={`sharing-popup`}>
					{this.contentPopup()}
				</Popup>
			)
		} else {
			return "";
		}
	}
}

const mapStateToProps = (state) => {
	return {
		autoComplete : state.sharingDetailsReducer.getAutoComplete,
        sharingDetailsLv2Popup: state.sharingDetailsReducer.getSharingDetailsLv2Popup,
		updateCollaborators: state.sharingDetailsReducer.updateCollaborators,
		isEmpty: state.addCollaboratorDetailsReducer.isEmpty,
		isEmailValid: state.addCollaboratorDetailsReducer.isEmailValid,
        profile : state.profileReducer.getProfile,
        collaboratorsPageNumber: state.sharingDetailsReducer.collaboratorsPageNumber,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
        setSelectLabelToAdd : (array) => {
            dispatch(selectLabelToAdd(array))
        },
        setSelectContactToAdd : (array) => {
            dispatch(selectContactToAdd(array))
        },
        getSharingDetailsLv2Popup: (array) => {
			dispatch(getSharingDetailsLv2Popup(array))
		},
		getAutoComplete: (string) => {
			dispatch(getAutoComplete(string))
		},
		autoCompleteEnteredValue: (string) => {
			dispatch(autoCompleteEnteredValue(string))
		},
        resetAddedCollaborators: () => {
            dispatch(resetAddedCollaborators())
		},
        addToContactSwitch: (boolean) => {
            dispatch(addToContactSwitch(boolean))
        },
		invalidShare: (boolean) => {
			dispatch(invalidShare(boolean))
		},
		ownershipChangeTarget: (boolean) => {
			dispatch(ownershipChangeTarget(boolean))
		},
		setIsEmpty : (boolean) => {
			dispatch(isEmpty(boolean))
		},
		setIsEmailValid : (boolean) => {
			dispatch(isEmailValid(boolean))
		},
        setCollaboratorsPageNumber : (int) => {
            dispatch(collaboratorsPageNumber(int))
        },
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SharingDetailsLv2Popup);
